import React, { FC } from 'react';
import { StyledCardWrapper, StyledTextPairing } from './Card.styles';
import { TextPairingProps } from '@components/TextPairing';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';

interface CardProps
  extends Pick<TextPairingProps, 'eyebrow' | 'eyebrowVariant' | 'eyebrowColor' | 'title' | 'titleVariant' | 'titleColor'> {
  wrapperStyles?: React.CSSProperties;
  handleClick?: () => void;
}

export const Card: FC<CardProps> = props => {
  const { eyebrow, title, eyebrowVariant, titleVariant, eyebrowColor, titleColor, children, wrapperStyles, handleClick } = props;

  return (
    <StyledCardWrapper style={wrapperStyles} onClick={handleClick}>
      <StyledTextPairing
        eyebrow={eyebrow}
        eyebrowVariant={eyebrowVariant}
        eyebrowColor={eyebrowColor}
        title={title}
        titleVariant={titleVariant}
        titleColor={titleColor}
      />
      {children}
    </StyledCardWrapper>
  );
};
